import React from 'react';
import Layout from '../../components/layout';
import Prevention from '../../components/one-oh-one/Prevention';

const headerText = 'SUBSTANCE USE 101';

const OneOhOne = () => {
  return (
    <Layout
      headerText={headerText}
      heroFont="has-text-white"
      heroBg="dark-hero"
    >
      <Prevention path="/one-oh-one/society" />
    </Layout>
  );
};

export default OneOhOne;
